import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Card } from "../ui/card";
import { Loader2, FileText, Clock } from "lucide-react";

function ProjectsModal({ isOpen, onClose, projects, isLoading, onLoadProject }) {
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl bg-[#1a1a2e] border-white/10">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-white">
            Load Saved Project
          </DialogTitle>
        </DialogHeader>

        <div className="mt-4">
          {isLoading ? (
            <div className="flex items-center justify-center py-12">
              <Loader2 className="w-8 h-8 animate-spin text-[#00d4aa]" />
            </div>
          ) : projects.length === 0 ? (
            <div className="text-center py-12 text-white/60">
              <FileText className="w-12 h-12 mx-auto mb-4 opacity-50" />
              <p>No saved projects found.</p>
              <p className="text-sm mt-2">Generate and save your first project to see it here!</p>
            </div>
          ) : (
            <div className="space-y-3 max-h-[500px] overflow-y-auto pr-2">
              {projects.map((project) => (
                <Card
                  key={project.id}
                  className="card cursor-pointer hover:border-[#00d4aa]/50 transition-all"
                  onClick={() => onLoadProject(project.id)}
                >
                  <div className="p-4">
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex-1">
                        <h3 className="font-semibold text-white mb-1">
                          {project.title}
                        </h3>
                        <div className="flex items-center gap-3 text-sm text-white/60">
                          <div className="flex items-center gap-1">
                            <Clock className="w-3 h-3" />
                            {new Date(project.created_at).toLocaleDateString()}
                          </div>
                          <span className="px-2 py-0.5 bg-white/10 rounded text-xs">
                            {project.status}
                          </span>
                        </div>
                      </div>
                      <Button
                        size="sm"
                        className="bg-[#00d4aa] hover:bg-[#00e6bb] text-black"
                        onClick={(e) => {
                          e.stopPropagation();
                          onLoadProject(project.id);
                        }}
                      >
                        Load
                      </Button>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ProjectsModal;